<template>
  <section>
    <main-body>
      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center"
      >
        Welcome
      </v-card-title>
      <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
        New to the area? Have you lived in Virginia for a while? Are you visiting for a while? Do you simply live close
        enough? Or maybe you just stumbled upon up! Regardless of how you find us, Welcome to the Furries of Virginia!
      </v-card-text>

      <v-divider class="my-5 mx-3" />

      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center"
      >
        Who are we?
      </v-card-title>
      <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
        We are the furries of Virginia. Our goal is to make it as easy as possible to find and interact with other furries
        in Virginia and nearby states! What is a furry you ask?
        <v-card
          class="mt-5 px-4 mx-auto blockquote wiki-quote"
          width="75%"
          shaped
        >
          “The furry fandom is a subculture interested in anthropomorphic animal characters with human personalities
          and characteristics.” ~Wikipedia</v-card>
      </v-card-text>

      <v-divider class="my-5 mx-3" />

      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center"
      >
        What do we do?
      </v-card-title>
      <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
        We provide a platform to find new friends, discover new hobbies, and enjoy the company of like minded furries.
        There are many ways we support this such as hosting events and providing online gathering spaces.
      </v-card-text>
    </main-body>
  </section>
</template>

<script>
  import MainBody from '../../core/components/MainBody'
  export default {
    name: 'HomeContents',
    components: { MainBody },
    component: {
      MainBody,
    },
  }
</script>
<style>
 .wiki-quote {
   border-style: solid;
   border-width: 0 0 0 15px;
   border-color: #EF5350 !important;
 }
</style>
